import { createUseStyles } from 'react-jss'

import { PurpleBase, RedDarken16, TextGreyBase, TextSlateGreyLighten16 } from '@/const/colors'
import { WidthBPs } from '@/const/commonStyles'
import { FontH3, FontH4 } from '@/const/fontStyles'

export default createUseStyles(
  {
    root: {
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'column',
      padding: '0 24px',
      marginTop: 90,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        padding: '0 40px',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
      },
    },
    container: {
      maxWidth: 629,
      width: '100%',
      minHeight: 368,
      marginBottom: 32,
      flexShrink: 0,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        marginBottom: 0,
      },
    },
    header: {
      marginBottom: 32,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        marginBottom: 40,
      },
    },
    title: {
      ...FontH4,
      color: TextGreyBase,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        ...FontH3,
      },
    },
    error: {
      marginTop: 4,
    },
    inputGroup: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: 16,
      marginBottom: 24,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        gridTemplateColumns: '1fr 1fr',
        gridGap: '24px 40px',
      },
    },
    checkboxGroup: {
      marginBottom: 32,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        marginBottom: 40,
      },
    },
    terms: {
      color: TextGreyBase,
    },
    link: {
      color: PurpleBase,
      textDecoration: 'none',
    },
    termsError: {
      color: RedDarken16,
    },
    buttonGroup: {
      display: 'flex',
    },
    countryWrapper: {
      marginBottom: 40,
    },
    country: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: 16,

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        gridTemplateColumns: '1fr 1fr',
        gridGap: '24px 40px',
      },
    },
    alerts: {
      marginTop: 16,
    },
    phoneDetail: {
      color: TextSlateGreyLighten16,
    },
  },
  { name: 'Signup' }
)
